import {
  TicketPriority,
  TicketStatus,
  TicketType,
} from "../types/supportTicket";
import type { PillTone } from "../components/ds/display/Pill";

export const TICKET_TYPE_LABELS: Record<TicketType, string> = {
  [TicketType.BUG]: "Bug",
  [TicketType.DATA_ISSUE]: "Data issue",
  [TicketType.QUESTION]: "Question",
  [TicketType.FEATURE_REQUEST]: "Feature request",
  [TicketType.OTHER]: "Other",
};

export const TICKET_PRIORITY_LABELS: Record<TicketPriority, string> = {
  [TicketPriority.LOW]: "Low",
  [TicketPriority.NORMAL]: "Normal",
  [TicketPriority.HIGH]: "High",
  [TicketPriority.BLOCKING]: "Blocking",
};

export const TICKET_PRIORITY_TONES: Record<TicketPriority, PillTone> = {
  [TicketPriority.LOW]: "ghost",
  [TicketPriority.NORMAL]: "info",
  [TicketPriority.HIGH]: "warn",
  [TicketPriority.BLOCKING]: "risk",
};

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  [TicketStatus.NEW]: "New",
  [TicketStatus.IN_PROGRESS]: "In progress",
  [TicketStatus.WAITING_ON_CUSTOMER]: "Waiting on customer",
  [TicketStatus.RESOLVED]: "Resolved",
  [TicketStatus.CLOSED]: "Closed",
};

export const TICKET_STATUS_TONES: Record<TicketStatus, PillTone> = {
  [TicketStatus.NEW]: "info",
  [TicketStatus.IN_PROGRESS]: "accent",
  [TicketStatus.WAITING_ON_CUSTOMER]: "warn",
  [TicketStatus.RESOLVED]: "ok",
  [TicketStatus.CLOSED]: "ghost",
};

/** Extensions without the leading dot, per docs/frontend-support-ticketing.md */
export const TICKET_ATTACHMENT_ALLOWED_EXTENSIONS = [
  "png",
  "jpeg",
  "gif",
  "webp",
  "pdf",
  "txt",
  "doc",
  "docx",
  "xls",
  "xlsx",
];

export const TICKET_ATTACHMENT_MAX_FILES = 5;
export const TICKET_ATTACHMENT_MAX_SIZE_MB = 15;
export const TICKET_SUBJECT_MAX_LENGTH = 500;
export const TICKET_BODY_MAX_LENGTH = 20000;
export const TICKET_STATUS_EXPLANATION_MAX_LENGTH = 4000;

// Shared list/filter config for SupportTicketsPage + SupportTicketTriagePage
export const SUPPORT_TICKET_PAGE_SIZE = 25;

export const TICKET_STATUS_FILTER_OPTIONS = [
  { value: "OPEN", label: "Open" },
  ...Object.values(TicketStatus).map((value) => ({
    value,
    label: TICKET_STATUS_LABELS[value],
  })),
];

export const TICKET_TYPE_FILTER_OPTIONS = Object.values(TicketType).map(
  (value) => ({ value, label: TICKET_TYPE_LABELS[value] }),
);

export const TICKET_PRIORITY_FILTER_OPTIONS = Object.values(TicketPriority).map(
  (value) => ({ value, label: TICKET_PRIORITY_LABELS[value] }),
);
